import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Icon, Label } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Tour from "~/models/Tour";
import Immersive3dTour from "~/models/Immersive3dTour/Immersive3dTour";

@observer
class TourUiMeet3dActiveLabel extends Component {
  render() {
    const { tour, t } = this.props;

    if (!tour || !tour.isUiMeet3dActive) {
      return null;
    }

    return (
      <Label>
        <Icon name="handshake" /> {t("uiMeet3d")}
      </Label>
    );
  }
}
TourUiMeet3dActiveLabel.propTypes = {
  // We have added some fields from the Tour at the Immersive3dTour object
  // We will use the same component for both
  tour: PropTypes.oneOfType([PropTypes.instanceOf(Tour), PropTypes.instanceOf(Immersive3dTour)]),
  t: PropTypes.func.isRequired,
};
export default withTranslation()(TourUiMeet3dActiveLabel);
